import clsx from 'clsx';
import React, { memo, useRef, useEffect } from 'react';
import { ColorNames } from '@/utils/constants';

import useStyles from './Overlay.styles';

const Overlay = ({
  className: overrideClassName,
  height = '100%',
  start = 0.65,
  end = 1,
  bgColor = ColorNames.charcoal,
}: any) => {
  const classes = useStyles({});
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (overlayRef?.current) {
        const overlayEl = overlayRef?.current;

        const area = end - start;
        const areaHeight = overlayEl.clientHeight * area;
        const startOffset = overlayEl.clientHeight * start;
        const top = areaHeight - (areaHeight - window.scrollY);
        const percent = (top - startOffset) / areaHeight;
        const minPercent = percent > 0 ? percent : 0;
        const opacity = minPercent < 1 ? minPercent : 1;

        overlayEl.style.opacity = opacity.toString();
      }
    };

    document.addEventListener('scroll', handleScroll);

    return () => document.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={clsx(classes.root, overrideClassName)} style={{ height }}>
      <div className={clsx(classes.overlay, `bg-color-${bgColor}`)} ref={overlayRef} />
    </div>
  );
};

export default memo(Overlay);
